export const cognitoPhoneRegex = /^(\+[0-9]{4,18})$/

/**
 * Validates given phone number against cognito phone number regex by default if regex is omitted.
 * Else It validates this phone number against custom regex
 */
export function validatePhoneNumber(number: string, regex = cognitoPhoneRegex): boolean {
    if (number.length === 0) {
        return true
    }
    return (number.match(regex) || []).length > 0
}
